import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Card } from '@blueprintjs/core';

import cls from './ContextualCard.module.css';

function getContextComponent(baseClassName) {
  return class extends PureComponent {
    static propTypes = {
      children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
      className: PropTypes.string,
      border: PropTypes.bool,
    };

    static defaultProps = {
      border: false,
    };

    static displayName = baseClassName;

    render() {
      const { children, className, border, ...props } = this.props;

      return (
        <div className={cx(baseClassName, { [cls.border]: border }, className)} {...props}>
          {children}
        </div>
      );
    }
  };
}

export default class extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    className: PropTypes.string,
  };

  static Top = getContextComponent(cls.topContext);

  static Main = getContextComponent(cls.mainContext);

  static Bottom = getContextComponent(cls.bottomContext);

  static Right = getContextComponent(cls.rightContext);

  static Floating = getContextComponent(cls.floatingContext);

  render() {
    const { children, className, ...props } = this.props;

    const childrenMap = {};

    React.Children.forEach(children, child => {
      if (child) {
        if (child.type.displayName === cls.floatingContext) {
          childrenMap[child.type.displayName] = (childrenMap[child.type.displayName] || []).concat(child);
        } else {
          childrenMap[child.type.displayName] = child;
        }
      }
    });

    return (
      <Card className={cx(cls.card, className)} {...props}>
        {childrenMap[cls.topContext]}
        {childrenMap[cls.mainContext]}
        {childrenMap[cls.bottomContext]}
        {childrenMap[cls.rightContext]}
        {childrenMap[cls.floatingContext]}
      </Card>
    );
  }
}
